import { Label } from '@creditflowresearch/uilib/Badge/Label';
import Tooltip from '@creditflowresearch/uilib/Tooltip';

interface ILabelCellProps {
  text: string,
  tooltip: string,
  color?: string,
  className?: string,
}

const LabelCell = ({ text, tooltip, color, className }: ILabelCellProps) => {
  return (
    <Tooltip placement="bottom" content={ tooltip }>
      <Label className={ className } backgroundColor={ color }>
        { text }
      </Label>
    </Tooltip>
  );
};

export default LabelCell;
